import initHeroAnimation from "./Components/initHeroAnimation";
import initHappyPeopleSection from "../Components/Sections/HappyPeopleSection";
import "Styles/Pages/ManageHybridWorkplacesLP.scss";

initHappyPeopleSection();
initHeroAnimation();